import { useState } from 'react';
import './InfoButton.scss';

function InfoButton(props) {
     const { side, children } = props;
     const [isHovered, setIsHovered] = useState(false);

     return (
          <div
               onMouseEnter={() => {
                    setIsHovered(true);
               }}
               onMouseLeave={() => {
                    setIsHovered(false);
               }}
               onClick={() => {
                    setIsHovered(!isHovered);
               }}
               className={`info__container info__container-${side} ${
                    isHovered && 'info__container-hover'
               }`}
          >
               <div className="info__picto">i</div>
               <div className="info__message">{children}</div>
          </div>
     );
}

export default InfoButton;
